import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccessGraphQL, beforeRequestError, signbeforeRequestSuccess } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const proxyClient = axios.create({
  baseURL: process.env.MARKETPLACE_API,
  pathToBeSetAsUrl: '/graphql/',
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

const oldInterceptorClient = axios.create({ // creating second client to be able to use different interceptors and loading screen
  baseURL: process.env.MARKETPLACE_API,
  pathToBeSetAsUrl: '/graphql/',
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

proxyClient.interceptors.request.use(signbeforeRequestSuccessGraphQL, beforeRequestError)
proxyClient.interceptors.response.use(onSuccess, onError)

oldInterceptorClient.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)
oldInterceptorClient.interceptors.response.use(onSuccess, onError)

export let gqlClient = proxyClient
export let gqlWithLoading = oldInterceptorClient



// WEBPACK FOOTER //
// ./src/api/marketplace/client.js